export const isString = (val) => {
    return (typeof val === 'string');
};
export const isStringWithValue = (val) => {
    return isString(val) && val.trim().length >= 1;
};
